var _style, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgR2C2Logo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 46 36",
    style: {
      enableBackground: "new 0 0 46 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.R2C2Logo-st0 {\r\n\t\t\tfill: url(#SVGID_1_);\r\n\t\t}\r\n\r\n\t\t.R2C2Logo-st1 {\r\n\t\t\tfill: url(#SVGID_00000030464125014492970900000002076375722343149714_);\r\n\t\t}\r\n\r\n\t\t.R2C2Logo-st2 {\r\n\t\t\tfill: url(#SVGID_00000058573097336833315590000011769979134534058123_);\r\n\t\t}\r\n\t")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.0989,
    y1: 35.9994,
    x2: 26.0989,
    y2: 16.6645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#437570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    style: {
      stopColor: "#52817C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#74A39F"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "R2C2Logo-st0",
    points: "12.9,36 19.4,36 32.5,36 34.9,29.5 21.6,29.5 23.9,22.9 37.3,22.9 39.3,16.7 19.7,16.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137830670003118714440000003299837261814057656_",
    gradientUnits: "userSpaceOnUse",
    x1: 23,
    y1: 35.9579,
    x2: 23,
    y2: -9.094947e-13
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#437570"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2618,
    style: {
      stopColor: "#52817C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#74A39F"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000137830670003118714440000003299837261814057656_)"
    },
    points: "13.5,0 11.1,6.5 0.4,36 7,36 17.7,6.5 36.3,6.5 32.7,16.1 39.6,16.1 43.2,6.5 45.6,0  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085249878559777283800000015818048955372798902_",
    gradientUnits: "userSpaceOnUse",
    x1: 12.8761,
    y1: 20.2948,
    x2: 39.6474,
    y2: 20.2948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001159978,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#22B49E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085249878559777283800000015818048955372798902_)"
    },
    d: "M35.1,16.7l-0.9,2.1H21l-5.3,15h17.5 l0.1,0.1L32.5,36H12.9l6.8-19.3H35.1z M18.4,4.6l-0.7,1.9h18.6l-3.5,9.5l2.4,0l4.5-11.5H18.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR2C2Logo);
export default __webpack_public_path__ + "static/media/R2C2Logo.db2a47b20d77bb7789a193ac664103aa.svg";
export { ForwardRef as ReactComponent };